var map = {
	"./en/popup.png": "rewo",
	"./es/popup.png": "l84S",
	"./pt/popup.png": "vAMc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oa+z";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/popup\.png$
// module id = oa+z
// module chunks = 0